import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { GetListParams, useGetList, UseGetListOptions } from 'react-admin';
import { MerchantAccount } from 'types/embedded/merchantAccount';
import { Provider } from 'types/embedded/provider';

type UseMerchantProvidersResult = {
  providers: Provider[];
  isPending: boolean;
  isLoading: boolean;
  total: number;
};

export const useMerchantProviders = (
  merchantId?: string,
  params?: Partial<GetListParams>,
  options?: UseGetListOptions<MerchantAccount>,
): UseMerchantProvidersResult => {
  const {
    data: merchantAccounts,
    isPending,
    isLoading,
  } = useGetList<MerchantAccount>(
    Resources.MerchantAccounts,
    {
      filter: { merchants: merchantId },
      pagination: UNLIMITED_PAGINATION_PARAMS,
      ...params,
    },
    {
      enabled: !!merchantId,
      ...options,
    },
  );

  const providers: Provider[] = merchantAccounts
    ? Object.values(
        merchantAccounts.reduce<Record<string, Provider>>((res, account) => {
          if (account.provider && !res[account.provider['@id']]) {
            res[account.provider['@id']] = account.provider;
          }
          return res;
        }, {}),
      )
    : [];

  return { providers, isPending, isLoading, total: providers.length ?? 0 };
};
